__turbopack_context__.v({
  "card": "tour-config-module__CD_uMq__card",
  "cardContainer": "tour-config-module__CD_uMq__cardContainer",
  "title": "tour-config-module__CD_uMq__title",
});
